export function getIsValue<T, F>(value: T | undefined, variant: F) {
  return value === variant;
}
